module.exports = __webpack_public_path__ + "img/bg9.7d2facc5.jpg";